import React, { useState } from 'react';
import logolong from '../assets/images/Logo_long.webp';
import { auth, signInWithEmailAndPassword, createUserWithEmailAndPassword, db } from "../firebase";
import { updateProfile, sendPasswordResetEmail } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import toast from "react-hot-toast";





const handleLogin = async (e) => {
    e.preventDefault()
    const userId = e.target.userId.value
    const password = e.target.password.value
    //console.log("Login Attempt: ", { userId, password })



    try {
        const userCredential = await signInWithEmailAndPassword(auth, userId, password);
        // redirect or update UI here
    } catch (error) {
        //console.error("Login failed:", error.message);
        //toast.error("Login failed: " + error.message);
        // Show error to user if needed
    } finally {
        toast.success("Connecté!")
    }


}
const handleSignup = async (e) => {
    e.preventDefault()
    const email = e.target.email.value
    const name = e.target.displayName.value;
    const password = e.target.password.value
    const passwordConfirm = e.target.password_confirm.value
    //console.log("Signup Attempt: ", { userId: email, password })

    if (password !== passwordConfirm) {
        toast.error("Les mots de passes ne se correspondent pas")
        return;
    }

    try {
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        await updateProfile(userCredential.user, { displayName: name });
        await setDoc(doc(db, "users", userCredential.user.uid), {
            displayName: name,
            email: email,
        });

    } catch (err) {
        console.error("Error:", err.message);
    } finally {
        toast.success("Le compte fut créé!")
    }

}
const handleReset = async (e) => {
    e.preventDefault();
    setLoading(true);
    const email = e.target.email.value;

    try {
        await sendPasswordResetEmail(auth, email);
        toast.success("E-mail de récuperation de mot de passe envoyé");
    } catch (error) {
        //console.error("Reset error:", error);
        //toast.error(error.message);
    } finally {
        setLoading(false)
    }
};
const ModifiedInfo = () => {
    const [loading, setLoading] = useState(false)
    const [resetEmail, setResetEmail] = useState("")
    const [activeTab, setActiveTab] = useState('who');
    return (
        <section id="aboutcontainer" className="about-area about-five">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-12">
                        <div className="about-image2" id="img2back">
                            <img src={logolong} alt="about"
                                id="image2" />
                        </div>
                    </div>
                    <div className="col-lg-6 col-12">
                        <div className="about-image2-content">
                            <h2> Espace Client</h2>
                            <div className="about-five-tab">
                                <nav>
                                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                        <button className={`nav-link ${activeTab === 'who' ? 'active' : ''}`}
                                            onClick={() => setActiveTab('who')} >
                                            Connexion
                                        </button>
                                        <button
                                            className={`nav-link ${activeTab === 'vision' ? 'active' : ''}`}
                                            onClick={() => setActiveTab('vision')}>
                                            Créer un compte
                                        </button>
                                        <button
                                            className={`nav-link ${activeTab === 'new' ? 'active' : ''}`}
                                            onClick={() => setActiveTab('new')}>
                                            Mot de passe oublié?
                                        </button>
                                    </div>
                                </nav>
                                <div className="tab-content" id="nav-tabContent">
                                    {activeTab === 'who' && (
                                        <div>
                                            <form onSubmit={handleLogin} className="contact-form">
                                                <h2 className="mb-4 text-center">Login</h2>

                                                <div className="row">
                                                    <div className="col-12 mb-3">
                                                        <input
                                                            type="text"
                                                            name="userId"
                                                            className="form-control"
                                                            placeholder="User ID"
                                                            required
                                                        />
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-12 mb-4">
                                                        <input
                                                            type="password"
                                                            name="password"
                                                            className="form-control"
                                                            placeholder="Password"
                                                            required
                                                        />
                                                    </div>
                                                </div>

                                                <div className="text-center">
                                                    <button type="submit" className="btn primary-btn rounded-full">
                                                        Login
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    )}
                                    {activeTab === 'vision' && (
                                        <div>
                                            <form onSubmit={handleSignup} className="contact-form">
                                                <h2 className="mb-4 text-center">Signup</h2>

                                                <div className="row">
                                                    <div className="col-md-6 mb-3">
                                                        <input
                                                            type="text"
                                                            name="email"
                                                            className="form-control"
                                                            placeholder="Email"
                                                            required
                                                        />
                                                    </div>

                                                    <div className="col-md-6 mb-3">
                                                        <input
                                                            type="text"
                                                            name="displayName"
                                                            className="form-control"
                                                            placeholder="Your name"
                                                            required
                                                        />
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-md-6 mb-3">
                                                        <input
                                                            type="password"
                                                            name="password"
                                                            className="form-control"
                                                            placeholder="Password"
                                                            required
                                                        />
                                                    </div>

                                                    <div className="col-md-6 mb-4">
                                                        <input
                                                            type="password"
                                                            name="password_confirm"
                                                            className="form-control"
                                                            placeholder="Confirm Password"
                                                            required
                                                        />
                                                    </div>
                                                </div>

                                                <div className="text-center">
                                                    <button type="submit" className="btn primary-btn rounded-full">
                                                        Sign up
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    )}
                                    {activeTab === 'new' && (
                                        <div>
                                            <form onSubmit={handleReset} className="contact-form">
                                                <h2 className="mb-4 text-center">Password Reset</h2>

                                                <div className="row">
                                                    <div className="col-12 mb-4">
                                                        <input
                                                            type="email"
                                                            name="email"
                                                            className="form-control"
                                                            placeholder="Email"
                                                            value={resetEmail}
                                                            onChange={(e) => setEmail(e.target.value)}
                                                            required
                                                        />
                                                    </div>
                                                </div>

                                                <div className="text-center">
                                                    <button
                                                        type="submit"
                                                        className="btn primary-btn rounded-full">
                                                        disabled={loading}
                                                        {loading ? "Sending..." : "Reset password"}
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </section >
    );
};

export default ModifiedInfo;